import React from "react";
import { IonButton } from "@ionic/react";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          alignContent: "center",
          marginTop: "40vh",
        }}
      >
        <IonButton
          color="secondary-light"
          onClick={() => {
            navigate({ pathname: "/" });
          }}
          expand="full"
          className="botaoLogar"
        >
          Entrar &nbsp; <i className="ri-shield-check-line"></i>
        </IonButton>
      </div>
    </>
  );
}
